module.exports = __webpack_public_path__ + "static/img/xmpj.f0ea3bf4.png";